{
  "slug": "cognitive-style-quiz",
  "title": "Cognitive Style Quiz",
  "description": "Reflect on problem-solving preferences without ranking styles.",
  "category": "Interactive tools",
  "sections": [
    {
      "heading": "Use the tool",
      "paragraphs": [
        "Complete the activity above. Results remain in this browser view and are educational."
      ]
    },
    {
      "heading": "Interpretation",
      "paragraphs": [
        "Device, display, input hardware, environment, familiarity, and variation affect a brief browser tool.",
        "It is not standardized, diagnostic, or suitable for a consequential decision."
      ]
    },
    {
      "heading": "Privacy and repeats",
      "paragraphs": [
        "The activity does not need your name. Avoid repeated attempts if you want to reduce practice effects.",
        "Seek a professional for health, vision, developmental, or clinical concerns."
      ]
    }
  ],
  "related": ["what-is-iq", "how-is-iq-measured", "iq-vs-intelligence"],
  "sources": [],
  "faqs": [
    {
      "question": "Is this result official?",
      "answer": "No. It is an educational browser activity."
    }
  ],
  "tool": "cognitive-style",
  "summary": "Reflect on problem-solving preferences without ranking styles. Content reviewed 18 July 2026."
}
